export var types = {
    CONNECT_SOCKET: 'CONNECT_SOCKET',
    CLOSE_SOCKET: 'CLOSE_SOCKET',
    SOCKET_MESSAGE: 'SOCKET_MESSAGE',
    SUBSCRIBE_TO_PROCESS: 'SUBSCRIBE_TO_PROCESS',
    UNSUBSCRIBE_TO_PROCESS: 'UNSUBSCRIBE_TO_PROCESS',
    SOCKET_OPEN: 'SOCKET_OPEN_MAT',
    SOCKET_ERROR: 'SOCKET_ERROR',
    SOCKET_CLOSE: 'SOCKET_CLOSE',
};
export var unsubscribeToProcess_AC = function (processes) {
    return {
        type: types.UNSUBSCRIBE_TO_PROCESS,
        payload: {
            processes: processes,
        },
    };
};
export var subscribeToProcess_AC = function (processes) {
    return {
        type: types.SUBSCRIBE_TO_PROCESS,
        payload: {
            processes: processes,
        },
    };
};
export var connectSocket_AC = function (params) {
    return {
        type: types.CONNECT_SOCKET,
        payload: params,
    };
};
export var closeSocket_AC = function () {
    return { type: types.CLOSE_SOCKET };
};
export var socketMessage_AC = function (event) {
    return {
        type: types.SOCKET_MESSAGE,
        payload: { data: JSON.parse(event.data) },
    };
};
export var socketOpen_AC = function () {
    return {
        type: types.SOCKET_OPEN,
    };
};
export var socketError_AC = function () {
    return {
        type: types.SOCKET_ERROR,
    };
};
export var socketClose_AC = function () {
    return {
        type: types.SOCKET_CLOSE,
    };
};
//# sourceMappingURL=websocket.js.map